var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function InfographicList(_ref) {
  var items = _ref.items,
    component = _ref.component,
    containerClass = _ref.containerClass,
    listClass = _ref.listClass,
    paneTitle = _ref.paneTitle,
    titleAlign = _ref.titleAlign;
  var ComponentToRender = component;
  var onClickAction = _ref.onClickAction;

  var content = _react["default"].createElement("div", null);

  var styles = {
    textAlign: titleAlign,
  };

  // If we have items, render them
  if (items) {
    content = items.map(function (item) {
      return _react["default"].createElement(ComponentToRender, {
        key: item.identifier,
        title: item.title,
        image: item.image,
        link: item.ref,
        index: item.id,
        identifier: item.identifier,
        publisher: item.publisher,
        theme: item.theme,
        keyword: item.keyword,
        description: item.description,
        onClickAction: onClickAction,
      });
    });
  } else {
    content = _react["default"].createElement(ComponentToRender, null);
  }

  if (paneTitle) {
    return _react["default"].createElement(
      "div",
      {
        className: "dc-infographic-list  ".concat(containerClass),
      },
      _react["default"].createElement(
        "h2",
        {
          className: "pane-title",
          style: styles,
        },
        paneTitle
      ),
      _react["default"].createElement(
        "ul",
        {
          className: "col-md-12",
        },
        content
      )
    );
  }

  return _react["default"].createElement(
    "div",
    {
      className: "dc-infographic-list  {containerClass}",
    },
    _react["default"].createElement(
      "ul",
      {
        className: listClass,
      },
      content
    )
  );
}

InfographicList.defaultProps = {
  listClass: "dc-infographic",
  containerClass: "container",
  paneTitle: "",
  titleAlign: "",
};
InfographicList.propTypes = {
  component: _propTypes["default"].func.isRequired,
  items: _propTypes["default"].arrayOf(
    _propTypes["default"].shape({
      title: _propTypes["default"].string,
      ref: _propTypes["default"].string,
      image: _propTypes["default"].string,
      identifier: _propTypes["default"].string,
      publisher: _propTypes["default"].string,
      keyword: _propTypes["default"].array,
      theme: _propTypes["default"].array,
      description: _propTypes["default"].string,
    })
  ).isRequired,
  listClass: _propTypes["default"].string,
  containerClass: _propTypes["default"].string,
  paneTitle: _propTypes["default"].string,
  titleAlign: _propTypes["default"].string,
};
var _default = InfographicList;
exports["default"] = _default;
